import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ListItem, MenuMoreLink } from '@app/model';

/**
 * A menu entry: a link, with the list type ('manual', 'dynamic') or 'company'
 * for the icon.
 */
export type ActionListItem = ListItem & {
  routerLink?: string;
  type?: string;
};

@Component({
  selector: 'app-action-list',
  templateUrl: './action-list.component.html',
  styleUrls: ['./action-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ActionListComponent<T extends ActionListItem> implements OnInit {
  @Input() id!: number | string;
  @Input() name = '';
  @Input() icon: string | null = null;
  @Input() action: string | null = null;
  @Input() items: T[] = [];
  /** The number of entries shown at most; null shows all. */
  @Input() limitItems: number | null = null;
  /** The link to all entries, shown when the limit cuts the list. */
  @Input() moreLink: MenuMoreLink | null = null;
  /** The text without entries, a translation key; none hides the hint. */
  @Input() emptyText: string | null = null;

  @Output() itemClicked = new EventEmitter<T>();
  @Output() actionClicked = new EventEmitter<void>();
  @Output() moreClicked = new EventEmitter<void>();

  ngOnInit(): void {}

  /** The entries within the limit. */
  get visibleItems(): T[] {
    return this.limitItems === null
      ? this.items
      : this.items.slice(0, this.limitItems);
  }

  get cut(): boolean {
    return this.visibleItems.length < this.items.length;
  }

  onItemClicked(e: { itemData: T }) {
    this.itemClicked.emit(e.itemData);
  }

  onActionClicked = () => {
    this.actionClicked.emit();
  };
}
